import hubStorage from '@/helpers/hubStorage';
export default {
    accessToken: hubStorage.getAccessToken(),
};
